import { createBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";
import React from "react";
import { RouterProvider } from "react-router-dom";
import LoadingOverlay from "@/components/atomic/LoadingOverlay";
import { Toaster } from "@/components/atomic/Toast";
import AuthProvider from "@/components/auth/AuthProvider";
import routerConfigArray from "@/configs/router.config";
import useConfig from "@/hooks/useConfig";
import useI18n from "@/hooks/useI18n";

const basename = import.meta.env.BASE_URL;

const App: React.FC = () => {
  const { config } = useConfig();
  // i18nフックを使用して言語設定を適用
  useI18n();

  const router = createBrowserRouter(routerConfigArray(config), { basename: basename });

  return (
    <AuthProvider>
      <RouterProvider
        router={router}
        fallbackElement={<LoadingOverlay />}
      />
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
};

export default App;
